import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function MediaUploadEventValue({ event }) {
  const { conversation_message_id, value } = event;
  const { t } = useLanguage();

  // value can be: string (legacy) or object {conversation_message_id, message_type, media_link}
  const messageId = conversation_message_id || (typeof value === 'object' ? value?.conversation_message_id : null) || value;
  // different from the previous, the media_link is according to config.system.nexi_public_base_url so, it will change according to the environment
  const mediaLink = typeof value === 'object' && value?.media_link ? value.media_link : (messageId ? `https://m.nexicare.ai/m/${messageId}` : null);

  const getMediaTypeLabel = () => {
    // The value might contain media type info, but typically it's just the message ID
    // We'll show a generic "Media Upload" label
    return t('mediaUpload.title', 'Media Upload');
  };

  const getMediaIcon = () => {
    // Since we don't have media_type in the event, use a generic icon
    return '📎';
  };

  return (
    <div className="space-y-2">
      {(messageId || mediaLink) && (
        <div className="space-y-2">
          <div className="text-sm text-gray-600">
            <a
              href={mediaLink || `https://m.nexicare.ai/m/${messageId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline inline-flex items-center gap-1"
            >
              {t('mediaUpload.viewMedia', 'View Media File')}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
